import React from 'react'
import { Helmet } from 'react-helmet'
// Custom hook to listen for messages and update styles
const IframeScript = () => {
  return (
    <Helmet>
      <script>{`
    
    window.embedPerceivedTop = 0;

    // Send the offset information to the parent window
    if (window.top && window.self !== window.top) {
      try {
        document.body.style.setProperty("overflow", "auto");
      } catch (e) {
        console.warn(e);
      }
     

      setInterval(
        function () {
          try {
            window.top.postMessage(
              { type: "RESIZE_INTERVAL", value: document.body.clientHeight },
              "*"
            );
          } catch (e) {}
        }.bind(this),
        500
      );
    }

    window.addEventListener("message", function (message) {
      // console.log(message.data.type)
      if (message.data.type === "PARENT_CONFIG") {
        // console.log(message.data.value)
        document.documentElement.style.setProperty("--content-min-height", message.data.value.height + "px");
        document.body.style.setProperty("--content-min-height", message.data.value.height + "px");
        document.body.style.setProperty("--embedPerceivedTop", (message.data.value.embedPerceivedTop || 0) + "px")

        document.body.classList.add("is-iframed")
        window.embedPerceivedTop = (message.data.value.embedPerceivedTop || 0);
        window.embedHeight = (message.data.value.height || 800);

      }

      if (message.data.type === "PARENT_SCROLL") {
        document.body.style.setProperty("--embedPerceivedTop", (message.data.value.embedPerceivedTop || 0) + "px")

        window.embedPerceivedTop = (message.data.value.embedPerceivedTop || 0);

        if (message.data.value.parentY < message.data.value.navHeight) {
          document.querySelector('nav.content').classList.add('init')
        } else {
          document.querySelector('nav.content').classList.remove('init')
        }

      }

      if (message.data.type === "SHOW_NAV") {
        document.querySelector('nav.content') && document.querySelector('nav.content').classList.remove('nav-bar--hidden');
        // console.log("SHOW ", document.querySelector('nav.content').getBoundingClientRect())
      }

      if (message.data.type === "HIDE_NAV") {
        document.querySelector('nav.content').classList.add('nav-bar--hidden');
      }

    });

`}</script>
    </Helmet>
  )
}
export default IframeScript
